import { getPaddleBillingConfig } from "./paddleBilling";

export const BASE_URL = "https://groupboss.io/api";

export const getToken = () => {
  const token = localStorage.getItem("access_token");
  return token;
};

export const setToken = (token) => {
  localStorage.setItem("access_token", token);
};

export const getValues = () => {
  const token = localStorage.getItem("values");
  return token;
};

export const setValues = (values) => {
  localStorage.setItem("values", values);
};

export const getdataVisible = () => {
  const token = localStorage.getItem("dataVisible");
  return token;
};

export const setdataVisible = (dataVisible) => {
  localStorage.setItem("dataVisible", dataVisible);
};

export const password_validate = (p) => {
  return /^(?=.*?[A-Z])(?=.*?[a-z]).{8,}$/.test(p);
};

export const validateEmail = (email) => {
  // eslint-disable-next-line
  let emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

export const reformatDate = (date) => {
  if (date === null || date === undefined || date === "") {
    return "";
  }
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const d = new Date(date);

  return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

function safeJsonParse(value, fallback = {}) {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

function normalizePlanCollection(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item));
  }

  if (typeof value === "string") {
    return value
      .replace("[", "")
      .replace("]", "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
}

function getPlanValue(planId, planType) {
  const normalizedPlanId = String(planId);

  for (const key in planType) {
    if (normalizePlanCollection(planType[key]).includes(normalizedPlanId)) {
      return key;
    }
  }
  return "";
}

export const getPlanType = (plan_id) => {
  const normalizedPlanId = String(plan_id || "");
  const { planTypeMap } = getPaddleBillingConfig();
  const classicPlanTypes = safeJsonParse(process.env.REACT_APP_PLAN_TYPES);

  if (!normalizedPlanId) {
    return "";
  }

  if (planTypeMap[normalizedPlanId]) {
    return planTypeMap[normalizedPlanId];
  }

  return getPlanValue(normalizedPlanId, classicPlanTypes);
};

export const getPlanName = (planId) => {
  const normalizedPlanId = String(planId || "");
  const { planNameMap } = getPaddleBillingConfig();
  const classicPlans = safeJsonParse(process.env.REACT_APP_PADDLE_PLANS);

  if (planNameMap[normalizedPlanId]) {
    return planNameMap[normalizedPlanId];
  }

  if (classicPlans[normalizedPlanId]) {
    return classicPlans[normalizedPlanId];
  }
  return "Unknown";
};

let currencies = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  ARS: "$",
  BRL: "R$",
  AUD: "$",
  CAD: "$",
  CHF: "Fr",
  COP: "$",
  CNY: "¥",
  CZK: "Kč",
  DKK: "kr",
  HKD: "$",
  HUF: "Ft",
  INR: "₹",
  ILS: "₪",
  JPY: "¥",
  KRW: "₩",
  MXN: "$",
  NOK: "kr",
  NZD: "$",
  PLN: "zł",
  RUB: "₽",
  SEK: "kr",
  SGD: "$",
  THB: "฿",
  TRY: "₺",
  TWD: "NT$",
  UAH: "₴",
  ZAR: "R",
};


export const getCurrencySymbol = (currency) => {
  if (currencies[currency]) {
    return currencies[currency];
  }
  return currency;
};
